import React from "react";
import { Modal } from "reactstrap"; 

const FilePreviewModal = ({
  isModalOpen,
  closeModal,
  previewImageUrl,
  fileExtension,
  isMobile,
  isLoading,     // Loading state to show the dimmed effect
}) => {
  const documentExtensions = ["pdf", "doc", "docx", "ppt", "pptx", "xls", "xlsx"];

  return (
    <Modal
      isOpen={isModalOpen}
      toggle={closeModal}
      size={"lg"}
      centered
      backdrop="static"
      keyboard={false}
    >
      <button
        onClick={closeModal}
        className="remove-button"
        style={{
          width: isMobile ? "30px" : "40px",
          height: isMobile ? "30px" : "40px",
        }}
        title="Remove file"
      >
        <i className="fa fa-close"></i>
      </button>
      <div style={{ textAlign: "center", padding: 20 }}>
        {previewImageUrl && (
          <>
            {/* Check if the file is a document type (PDF, DOC, etc.) */}
            {documentExtensions.includes(fileExtension) ? (
              <iframe
                title="Google Docs Document"
                src={`https://docs.google.com/viewer?url=${previewImageUrl}&embedded=true&output=embed`}
                width="100%"
                height="100%"
                frameBorder="0"
                style={{ opacity: isLoading ? 0.5 : 1 }} // Optional: dim the iframe during loading
              />
            ) : (
              <>
                {/* Check for video files based on the file extension */}
                {["mp4", "avi", "mkv", "mov", "mpeg", "wmv"].includes(fileExtension) ? (
                  <video
                    controls
                    style={{
                      maxWidth: "100%",
                      maxHeight: 400,
                      borderRadius: 8,
                    }}
                  >
                    <source src={previewImageUrl} type={`video/${fileExtension}`} />
                    <p>Your browser does not support the video tag.</p>
                  </video>
                ) : (
                  // For image files
                  <img
                    src={previewImageUrl}
                    alt="Preview"
                    style={{
                      maxWidth: "100%",
                      maxHeight: 400,
                      borderRadius: 8,
                    }}
                  />
                )}
              </>
            )}
          </>
        )}
      </div>
    </Modal>
  );
};

export default FilePreviewModal;
